import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import Submitable, { SubmitEventListener } from '@philips-emr/tws-core/lib/component/types/submitable';
import { createAbort, noop } from '@philips-emr/tws-utils';

class FilterAPI extends ComponentAPI implements Submitable {

  /** @event */
  @AwesomeEvent
  onBeforeSubmit = new SubmitEventListener();

  /** @event */
  @AwesomeEvent
  onSubmit = new SubmitEventListener();

  /** @event */
  @AwesomeEvent
  onBeforeCancel = new SubmitEventListener();

  /** @event */
  @AwesomeEvent
  onCancel = new SubmitEventListener();

  getTitle(): string {
    return this.state.title;
  }

  setTitle(title: string): void {
    this.setState({ title });
  }

  getData(): object {
    return this.state.data;
  }

  setData(data: object): void {
    this.setState({ data });
  }

  getRecordMapper(): Record<string, string> {
    return this.state.recordMapper;
  }

  setRecordMapper(recordMapper: Record<string, string>): void {
    this.setState({ recordMapper });
  }

  getRecord(): object {
    return this.state.record;
  }

  setRecord(record: object): void {
    this.setState({ record: record || this.state.data });
  }

  submit(): void {
    const record = this.getRecord();

    const abort = createAbort();

    this.onBeforeSubmit.fire({ record, abort });

    abort.promise.then(aborted => {
      if (aborted) return;

      this.onSubmit.fire({ record, abort: noop });
    });
  }

  cancel(): void {
    const record = this.getRecord();

    const abort = createAbort();

    this.onBeforeCancel.fire({ record, abort });

    abort.promise.then(aborted => {
      if (aborted) return;

      this.setRecord(this.state.data);
      this.onCancel.fire({ record, abort: noop });
    });
  }

}

export default FilterAPI;
